import { Box } from "@mui/material"
import type { FC } from "react"

import DisplayAS400Id from "@/components/common/DisplayAS400Id/DisplayAS400Id"
import { StatusIndicator } from "@/components/common/StatusIndicator/StatusIndicator"
import { ComputedProductStatus } from "@/graphql/codegen/graphql"
import type { ProductVersionInfo } from "@/graphql/codegen/graphql"
import { ComputedProductStatusMap } from "@/screens/Companies/products/utils/productStatusMap"
import { ProductVersionChip } from "@/screens/Products/components/ProductVersionChip"

interface InventoryAdjustmentHistoryProductIdCellProduct {
  productId: number
  productPublicId?: string | null
  productExternalSystemId?: string | null
  productVersionNumber?: number | null
  productVersionDate?: string | null
}

interface InventoryAdjustmentHistoryProductIdCellProps {
  product: InventoryAdjustmentHistoryProductIdCellProduct
}

export const InventoryAdjustmentHistoryProductIdCell: FC<InventoryAdjustmentHistoryProductIdCellProps> = ({
  product,
}) => {
  const { productId, productPublicId, productExternalSystemId, productVersionNumber, productVersionDate } = product
  const aerosId = productPublicId ?? String(productId)

  const version: ProductVersionInfo | undefined =
    productVersionNumber !== null && productVersionNumber !== undefined
      ? ({
          versionNumber: productVersionNumber,
          releaseDate: productVersionDate ?? "",
        } as ProductVersionInfo)
      : undefined

  return (
    <div className='flex flex-col items-start gap-2'>
      <Box className='flex flex-col gap-1'>
        <Box className='flex items-center gap-2 px-1'>
          <StatusIndicator status={ComputedProductStatus.Active} map={ComputedProductStatusMap} />
          <span>{aerosId}</span>
        </Box>
        {productExternalSystemId && (
          <Box>
            <DisplayAS400Id id={productExternalSystemId} />
          </Box>
        )}
      </Box>
      {version && <ProductVersionChip version={version} />}
    </div>
  )
}
